import React from 'react';
import { Link } from 'react-router';
import { seeAllUrl } from '../../utils';
import { link as linkStyle } from './styles.module.css';

const SeeAllLink = ({
  query,
  totalEventCount,
  countryCode,
  onClick = () => {},
}) => {
  const text =
    totalEventCount > 0
      ? `Show all ${totalEventCount} events matching '${query}'`
      : 'No events found, see all events';
  const url =
    totalEventCount > 0
      ? seeAllUrl(countryCode, query)
      : seeAllUrl(countryCode);

  return (
    <Link to={url} className={linkStyle} onClick={onClick}>
      {text}
    </Link>
  );
};

export default SeeAllLink;
